import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { companyProfileAPIUrls } from '../data';

type Response = {
  success: boolean;
  message: string;
};

export const updateCompanyProfile = withLogger(
  async (payload): Promise<Response> => {
    const url = companyProfileAPIUrls.save;

    const { data } = await authServiceAxiosClient.post<Response>(url, payload);

    return data;
  },
);
